/////////////////////////////////RealRunning code::::::::::::::
import { actionType } from "./../actionType/actionType";
import toast from "react-hot-toast";
import { adminFRM, faceCheck, checkIn } from "../../API/API";

const data = JSON.parse(localStorage.getItem("data"));
const currentLocation = JSON.parse(localStorage.getItem("currentLocation"));

// To Check adminFRM and Check Face Detection Along with Check In

export const checkInTime = (
  cmd,
  userID,
  empID,
  token,
  photo,
  latlong,
  location,
  distance,
  accuracy,
  //mac_id,
  user_site,
  mac_id,
) => {
  return async (dispatch) => {
    //First We Check admin FRM returns ON or OFF
    try {
      const response = await adminFRM(userID, empID, token);

      if (response && response.status === 200 && response.data.FRM === "ON") {
        //If Data FRM returns Yes
        const url ="https://frs.ncrtc.in/" //response.data.IP;
        const apiKey = "58d73a6e-81ce-4df4-afed-2b4ae4ef9742" //response.data.APIKEY;

        try {
          const response2 = await faceCheck(url, apiKey);

          //Then Face recognition starts
          if (parseInt(response2.data.code) === 28) {
            //Face Not Matched or Not able to detect
            toast("Face Not Matched!! Try Again", {
              icon: "❗",
              duration: 4500,
            });

            if(cmd==="CheckIn"){
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }else if(cmd==="CheckOut"){
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }

            return false;
          }
          if (response2.data.result.length > 1) {
            //If Multiple Faces detected
            toast("Multiple Faces Detected!! Try Again", {
              icon: "❗",
              duration: 4500,
            });
            if(cmd==="CheckIn"){
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }else if(cmd==="CheckOut"){
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
            return false;
          }
          if (response2.data.result[0].subjects[0].subject !== empID) {
            //Face matches SomeOther employee
            toast(
              `Face not matching. Facial data similar to Emp ID - ${response2.data.result[0].subjects[0].subject}`,
              {
                icon: "❗",
                duration: 4500,
              }
            );
            if(cmd==="CheckIn"){
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }else if(cmd==="CheckOut"){
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
            
            return false;
          }
          if (
            response2.data.result[0].subjects[0].subject === empID &&
            parseFloat(response2.data.result[0].subjects[0].similarity) >= 0.2
          ) {
            //Face matches
            try {
              const response3 = await checkIn(
                cmd,
                userID,
                empID,
                token,
                photo,
                latlong,
                location,
                distance,
                accuracy,
                mac_id,
                user_site
                
              );
              if (response3.data.response === "OK") {
                toast.success("Attendance Has Been Marked SuccessFully", {
                  duration: 3000,
                });
                toast.success("Face Matched", {
                  duration: 3000,
                });

                if(cmd==="CheckIn"){
                  dispatch({
                    type: actionType.CLOSE_CHECKIN,
                    payload: false,
                  });
                }else if(cmd==="CheckOut"){
                  dispatch({
                    type: actionType.CLOSE_CHECKOUT,
                    payload: false,
                  });
                }
              }
            } catch (error) {
              toast.error(error.message);
            }
          }
        } catch (error) {
          //Incase Face Check Not Working
          try {
            const response4 = await checkIn(
              cmd,
              userID,
              empID,
              token,
              photo,
              latlong,
              location,
              distance,
              accuracy,
              mac_id,
              user_site
              //mac_id
            );
            if (response4.data.response === "OK") {
              toast.success(
                "Facial Data Captured and Attendance Has Been Marked SuccessFully",
                {
                  duration: 5000,
                }
              );
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }
          } catch (error) {}
        }
      } else if (
        response &&
        response.status === 200 &&
        response.data.FRM === "OFF"
      ) {
        try {
          const response = await checkIn(
            cmd,
            userID,
            empID,
            token,
            photo,
            latlong,
            location,
            distance,
            accuracy,
            mac_id,
            user_site
            //mac_id
          );
          if (response.data.response === "OK") {
            toast.success(
              "Attendance has been Marked Successfully and Facial Data Has Been Captured",
              {
                duration: 5000,
              }
            );
            if(cmd==="CheckIn"){
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }else if(cmd==="CheckOut"){
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
          }
        } catch (error) {}
      }
    } catch (error) {
      toast.error("Face Recoginition Check Error, Please try after sometime.", {
        duration: 3000,
      });
    }
  };
};

//For CheckOut

export const checkOutTime = (
  cmd,
  userID,
  empID,
  token,
  photo,
  latlong,
  location,
  distance,
  accuracy,
  mac_id,
  user_site
  //mac_id
) => {
  return async (dispatch) => {
    //First We Check admin FRM returns ON or OFF
    try {
      const response = await adminFRM(userID, empID, token);

      if (response && response.status === 200 && response.data.FRM === "ON") {
        //If Data FRM returns Yes
        const url = response.data.IP;
        const apiKey = response.data.APIKEY;

        try {
          const response2 = await faceCheck(url, apiKey);

          //Then Face recognition starts

          if (parseInt(response2.data.code) === 28) {
            //Face Not Matched or Not able to detect
            toast.error("Face Not Matched!! Try Again", { duration: 3000 });
            dispatch({
              type: actionType.CLOSE_CHECKOUT,
              payload: false,
            });
            return false;
          }
          if (response2.data.result.length > 1) {
            //If Multiple Faces detected
            toast.error("Multiple Faces Detected!! Try Again", {
              duration: 3000,
            });
            dispatch({
              type: actionType.CLOSE_CHECKOUT,
              payload: false,
            });
            return false;
          }
          if (response2.data.result[0].subjects[0].subject !== empID) {
            //Face matches SomeOther employee
            toast.error(
              `Face not matching. Facial data similar to Emp ID - ${response2.data.result[0].subjects[0].subject}`,
              {
                duration: 3000,
              }
            );
            dispatch({
              type: actionType.CLOSE_CHECKIN,
              payload: false,
            });
            return false;
          }
          if (
            response2.data.result[0].subjects[0].subject === empID &&
            parseFloat(response2.data.result[0].subjects[0].similarity) >= 0.2
          ) {
            //Face matches
            const response3 = await checkIn(
              cmd,
              userID,
              empID,
              token,
              photo,
              latlong,
              location,
              distance,
              accuracy,
              mac_id,
              user_site
              //mac_id
            );
            if (response3.data.response === "OK") {
              toast.success("Attendance Has Been Marked SuccessFully", {
                duration: 3000,
              });
              toast.success("Face Matched", {
                duration: 3000,
              });
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
          }
        } catch (error) {
          //Incase Face Check Not Working
          try {
            const response = await checkIn(
              cmd,
              userID,
              empID,
              token,
              photo,
              latlong,
              location,
              distance,
              accuracy,
              mac_id,
              user_site
              //mac_id
            );
            if (response.data.response === "OK") {
              toast.success(
                "Facial Data Captured and Attendance Has Been Marked SuccessFully",
                {
                  duration: 5000,
                }
              );
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
          } catch (error) {}
        }
      } else if (
        response &&
        response.status === 200 &&
        response.data.FRM === "OFF"
      ) {
        try {
          const response = await checkIn(
            cmd,
            userID,
            empID,
            token,
            photo,
            latlong,
            location,
            distance,
            accuracy,
            mac_id,
            user_site
            //mac_id
          );
          if (response.data.response === "OK") {
            toast.success(
              "Attendance has been Marked Successfully and Facial Data Has Been Captured",
              {
                duration: 5000,
              }
            );
            dispatch({
              type: actionType.CLOSE_CHECKOUT,
              payload: false,
            });
          }
        } catch (error) {}
      }
    } catch (error) {
      toast.error("Face Recoginition Check Error, Please try after sometime.", {
        duration: 3000,
      });
    }
  };
};

  /////Testing Code:::

// import { actionType } from "./../actionType/actionType";
// import toast from "react-hot-toast";
// import { adminFRM, faceCheck, checkIn } from "../../API/API";
// import axios from "axios";

// const data = JSON.parse(localStorage.getItem("data"));
// const currentLocation = JSON.parse(localStorage.getItem("currentLocation"));

// export const checkInTime = (
//   cmd,
//   userID,
//   empID,
//   token,
//   photo,
//   latlong,
//   location,
//   distance,
//   accuracy,
//   user_site,
//   mac_id
// ) => {
//   return async (dispatch) => {
//     try {
//       // Step 0: Check if FRM is ON
//       const response = await adminFRM(userID, empID, token);

//       let faceMatched = false;
//       const duhaiURL = "https://frs.ncrtc.in/";
//       const duhaiAPIKey = "58d73a6e-81ce-4df4-afed-2b4ae4ef9742";

//       // If FRM is ON → do face recognition
//       if (response?.status === 200 && response.data.FRM === "ON") {
//         // Step 1: Check Duhai FRM first
//         try {
//           const duhaiFace = await faceCheck(duhaiURL, duhaiAPIKey);
//           console.log("Duhai Face Response:", duhaiFace.data);

//           if (
//             duhaiFace.data.result?.length > 0 &&
//             duhaiFace.data.result[0].subjects?.length > 0 &&
//             duhaiFace.data.result[0].subjects[0].subject.toString().trim() === empID.toString().trim() &&
//             parseFloat(duhaiFace.data.result[0].subjects[0].similarity) >= 0.2
//           ) {
//             faceMatched = true;
//             console.log("Face matched in Duhai");
//           }
//         } catch (err) {
//           console.warn("Duhai Face Check failed:", err.message);
//         }

//         // Step 2: If Duhai didn't match → check Corporate
//         if (!faceMatched) {
//           try {
//             const corporateURL = response.data.IP;
//             const corporateAPIKey = response.data.APIKEY;
//             const corpFace = await faceCheck(corporateURL, corporateAPIKey);

//             console.log("Corporate Face Response:", corpFace.data);

//             if (
//               corpFace.data.result?.length > 0 &&
//               corpFace.data.result[0].subjects?.length > 0 &&
//               corpFace.data.result[0].subjects[0].subject.toString().trim() === empID.toString().trim() &&
//               parseFloat(corpFace.data.result[0].subjects[0].similarity) >= 0.2
//             ) {
//               faceMatched = true;
//               console.log("Face matched in Corporate");

//               // Step 3: Auto-enroll face in Duhai for next time
//               try {
//                 const formData = new FormData();
//                 formData.append("data", photo);
//                 formData.append("empid", empID);
//                 formData.append("url1", duhaiURL);
//                 formData.append("APIKEY", duhaiAPIKey);

//                 await axios.post(`${duhaiURL}enroll`, formData, {
//                   headers: { "Content-Type": "multipart/form-data" },
//                 });

//                 console.log("Face auto-enrolled in Duhai successfully");
//               } catch (err) {
//                 console.warn("Duhai auto-enroll failed:", err.message);
//               }
//             }
//           } catch (err) {
//             toast.error("Corporate Face Check Failed");
//             console.error(err);
//           }
//         }

//         // Step 4: Mark attendance if face matched
//         if (faceMatched) {
//           try {
//             const attendanceResponse = await checkIn(
//               cmd,
//               userID,
//               empID,
//               token,
//               photo,
//               latlong,
//               location,
//               distance,
//               accuracy,
//               mac_id,
//               user_site
//             );

//             if (attendanceResponse.data.response === "OK") {
//               toast.success("Attendance Marked Successfully", { duration: 3000 });
//               toast.success("Face Matched", { duration: 3000 });
//             } else {
//               toast.error("Attendance Mark Failed");
//             }
//           } catch (err) {
//             toast.error(err.message);
//           }
//         } else {
//           // Only show error if BOTH Duhai and Corporate failed
//           toast.error(
//             "Face Not Matched in Duhai or Corporate. Please ensure your face is registered."
//           );
//         }

//         // Step 5: Close UI
//         if (cmd === "CheckIn") {
//           dispatch({ type: actionType.CLOSE_CHECKIN, payload: false });
//         } else if (cmd === "CheckOut") {
//           dispatch({ type: actionType.CLOSE_CHECKOUT, payload: false });
//         }

//       } else {
//         // FRM OFF → direct check in
//         await checkIn(cmd, userID, empID, token, photo, latlong, location, distance, accuracy, mac_id, user_site);
//         toast.success("Attendance Marked Successfully (FRM OFF)", { duration: 3000 });
//       }
//     } catch (error) {
//       toast.error("Face Recognition Check Error, Please try after sometime.");
//       console.error(error);
//     }
//   };
// };



